import BaseFactory from 'services/sports/default/base-factory';
import SimplexClassic from './simplex-classic';
import Const from 'constants';
import {Simplex} from 'services/sports/default/simplex';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: SimplexClassic,
    [Const.GAME_TYPE_SINGLEGAME]: Simplex,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
